import { getColumns } from './EnterprisesTable.consts';
import { PanelTable } from '../../../SearchPanel/PanelTable';
import { useEnterpriseStore } from '@/stores/EnterpriseStore/EnterpriseStore';

export const EnterprisesTable: React.FC = () => {
  const enterprises = useEnterpriseStore((state) => state.items);

  return <PanelTable data={enterprises} columns={getColumns()} />;
};
